import React, { useEffect } from 'react';
import { initMetaPixel } from '../lib/metaPixel';
/**
 * Mount once at the root of the app to load the Meta (Facebook) Pixel
 * and fire the initial PageView event.
 */
export function MetaPixel() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return null;
}